export const formatMoney = (money = 0, decimal = 2) => {
  const numStr = money.toString();
  const hasDecimal = numStr.includes('.');
  if (hasDecimal) {
    const [integerPart, decimalPart] = numStr.split('.');
    const formattedDecimal = decimalPart.length >= decimal ? decimalPart.slice(0, decimal) : decimalPart.padEnd(decimal, '0');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${formattedInteger}.${formattedDecimal}`;
  } else {
    const formattedInteger = numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const formattedDecimal = '0'.repeat(decimal);
    return `${formattedInteger}.${formattedDecimal}`;
  }
}
export const formatNum = (numebr = 0) => {
  const numStr = numebr.toString();
  const hasDecimal = numStr.includes('.');
  if (hasDecimal) {
    const [integerPart, decimalPart] = numStr.split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${formattedInteger}.${decimalPart}`;
  }
  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}